/*
 * RoboPixel customizer runtime bootstrap.
 *
 * Shopify can re-render section HTML without executing an inline bootstrap.
 * Loading this small file from the layout keeps the heavy editor inert during
 * the landing paint while guaranteeing that the first real interaction wakes
 * the editor before existing inline handlers run.
 */
(function () {
  var readyCallbacks = [];
  var activationStarted = false;
  var idleHandle = 0;
  var delayTimer = 0;
  var intentEvents = ['pointerdown', 'touchstart', 'keydown'];

  window.RoboPixelCustomizerReady = function (callback) {
    if (typeof callback !== 'function') return;
    if (window.__rpCustomizerRuntimeReady) callback();
    else readyCallbacks.push(callback);
  };

  function removeIntentListeners() {
    intentEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, activateRuntime, true);
    });
  }

  function activateRuntime() {
    if (activationStarted) return;
    activationStarted = true;
    clearTimeout(delayTimer);
    if (idleHandle && 'cancelIdleCallback' in window) cancelIdleCallback(idleHandle);
    removeIntentListeners();

    document.querySelectorAll('link[rel="preload"][data-rp-customizer-style]').forEach(function (style) {
      style.rel = 'stylesheet';
    });

    document.querySelectorAll('script[type="text/plain"][data-rp-customizer-runtime]').forEach(function (source) {
      var script = document.createElement('script');
      script.textContent = source.textContent;
      source.replaceWith(script);
    });

    window.__rpCustomizerRuntimeReady = true;
    readyCallbacks.splice(0).forEach(function (callback) {
      try {
        callback();
      } catch (error) {
        console.error('Customizer initialization failed:', error);
      }
    });
    document.dispatchEvent(new CustomEvent('robopixel:customizer-ready'));
  }

  function hasEditorDeepLink() {
    try {
      var params = new URLSearchParams(window.location.search);
      return !!(params.get('model') || '').trim() || params.get('start') === 'upload';
    } catch (error) {
      return false;
    }
  }

  // A model selected on an SEO collection page is already an explicit shopper
  // choice. Consume that handoff immediately so the visitor lands on the design
  // canvas instead of briefly seeing (and potentially reusing) the phone picker
  // while the normal idle activation waits. Brand-only and direct visits retain
  // the deferred runtime/LCP optimization because they still need Step 1.
  // An upload-first link also expresses editor intent. Show its upload preview
  // immediately instead of leaving shoppers on the phone picker during idle delay.
  // A phone tapped before this bootstrap downloaded is already user intent.
  // Do not make that queued tap wait through the idle activation delay.
  if (hasEditorDeepLink() || window.RoboPixelPendingModel) {
    activateRuntime();
    return;
  }

  intentEvents.forEach(function (eventName) {
    window.addEventListener(eventName, activateRuntime, { capture: true, passive: true });
  });

  function scheduleIdleActivation() {
    delayTimer = setTimeout(function () {
      if ('requestIdleCallback' in window) {
        idleHandle = requestIdleCallback(activateRuntime, { timeout: 2000 });
      } else {
        delayTimer = setTimeout(activateRuntime, 500);
      }
    }, 4500);
  }

  if (document.readyState === 'complete') scheduleIdleActivation();
  else window.addEventListener('load', scheduleIdleActivation, { once: true });
})();
